import { fetchAPI } from "./baseApi";

export async function getPartnersAdmin() {
  return fetchAPI("/partners/admin", { method: "GET" });
}

export async function createPartner(data) {
  return fetchAPI("/partners/admin", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function updatePartner(id, data) {
  return fetchAPI(`/partners/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
}

export async function deletePartner(id) {
  return fetchAPI(`/partners/admin/${id}`, { method: "DELETE" });
}
